<template lang="pug">
  .root
    TheHeading(:caption="'Администрирование'")
    page-list(:list="administrationList")
</template>

<script>
import administrationList from '../../data/lists/administrationList'
import PageList from '@/components/parts/PageList'
import TheHeading from '@/components/parts/TheHeading'

export default {
  components: {
    PageList,
    TheHeading
  },
  data () {
    return {
      administrationList
    }
  }
}
</script>
